import { Checkbox, Input } from 'antd';
import { useState } from 'react';

const { TextArea } = Input;

function Page2({ manager }) {
	const [managerApproved, setManagerApproved] = useState(false);
	return (
		<div className="bg-white">
			{/* Justification for Multiple Access Request */}
			<div className="mb-6">
				<h2 className="text-sm font-bold mb-3">
					Justification for Multiple Access Request
				</h2>
				<div className="border-2 border-black">
					<TextArea rows={4} className="border-0 rounded-none" placeholder="" />
				</div>
			</div>

			{/* Additional Information or Comments */}
			<div className="mb-6">
				<h2 className="text-sm font-bold mb-3">
					Additional Information or Comments
				</h2>
				<div className="border-2 border-black">
					<TextArea rows={4} className="border-0 rounded-none" placeholder="" />
				</div>
			</div>

			{/* User Details Update Section */}
			<div className="mb-6">
				<h2 className="text-sm font-bold mb-3">
					Please fill in for any User details update (other than email address
					change)
				</h2>

				{/* Yellow Warning Note */}
				<div
					className="bg-yellow-300 border border-yellow-400 p-3 mb-4"
					data-pdf-section>
					<p className="text-xs text-black m-0 italic">
						<span className="font-semibold">Note:</span> This section can be
						ignored if the request is for New, Termination or User role
						amendment request. For email address change, need to be raised as
						New User request. .
					</p>
				</div>

				{/* User Details Table */}
				<div className="border-2 border-black">
					{[
						{ label: 'USER FIRST NAME', key: 'firstName' },
						{ label: 'USER LAST NAME', key: 'lastName' },
						{ label: 'USER WWID (IF JNJ USER ONLY)', key: 'wwid' },
						{ label: 'USER COMPANY (IF NON JNJ USER ONLY)', key: 'company' },
						{ label: 'USER COUNTRY', key: 'country' },
						{ label: 'USER CONTACT NUMBER', key: 'contact' },
					].map((field, index, array) => (
						<div
							key={field.key}
							className={`grid grid-cols-2 ${
								index < array.length - 1 ? 'border-b-2 border-black' : ''
							}`}>
							<div className="border-r-2 border-black p-3 bg-white">
								<span className="font-bold text-sm">{field.label}</span>
							</div>
							<div className="p-0">
								<Input className="border-gray-300 rounded-5 h-full" />
							</div>
						</div>
					))}
				</div>
			</div>
			{/* Approval Section */}
			<div className="mb-8">
				<h2 className="text-sm font-bold mb-2">APPROVAL SECTION</h2>
				<p className="text-xs text-gray-700 mb-4">
					<span className="font-semibold">
						User`&aposs Manager Detail and Signature
					</span>{' '}
					(For NON JNJ User; JNJ individual responsible for the contract /
					agreement needs to sign)
				</p>

				{/* Manager Details Table */}
				<div className="border-2 border-black mb-6">
					{/* Manager Name */}
					<div className="grid grid-cols-2 border-b-2 border-black">
						<div className="border-r-2 border-black p-3 bg-white">
							<span className="font-bold text-sm">MANAGER NAME</span>
						</div>
						<div className="p-0">
							<Input className="border-gray-300 rounded-5 h-full" />
						</div>
					</div>

					{/* Manager Email */}
					<div className="grid grid-cols-2 border-b-2 border-black">
						<div className="border-r-2 border-black p-3 bg-white">
							<span className="font-bold text-sm">MANAGER EMAIL ID</span>
						</div>
						<div className="p-0">
							<Input className="border-gray-300 rounded-5 h-full" />
						</div>
					</div>

					{/* Manager WWID */}
					<div className="grid grid-cols-2 border-b-2 border-black">
						<div className="border-r-2 border-black p-3 bg-white">
							<span className="font-bold text-sm">MANAGER WWID</span>
						</div>
						<div className="p-0">
							<Input className="border-gray-300 rounded-5 h-full" />
						</div>
					</div>

					{/* Manager Contact Number */}
					<div className="grid grid-cols-2 border-b-2 border-black">
						<div className="border-r-2 border-black p-3 bg-white">
							<span className="font-bold text-sm">MANAGER CONTACT NUMBER</span>
						</div>
						<div className="p-0">
							<Input className="border-gray-300 rounded-5 h-full" />
						</div>
					</div>

					{/* Confirmation Checkbox */}
					<div className="grid grid-cols-12 border-b-2 border-black">
						<div className="col-span-10 border-r-2 border-black p-3 bg-white">
							<span className="font-bold text-sm">
								I confirm I reviewed the segregation of duties, and I hereby
								approve it.
							</span>
						</div>
						<div className="col-span-2 flex items-center justify-center p-3">
							<Checkbox
								checked={managerApproved}
								onChange={e => setManagerApproved(e.target.checked)}
							/>
						</div>
					</div>

					{/* Manager Signature */}
					<div className="grid grid-cols-2">
						<div className="border-r-2 border-black p-3 bg-white">
							<span className="font-bold text-sm">MANAGER SIGNATURE</span>
						</div>
						<div className="p-0">
							{manager?.image && (
								<img
									src={manager?.image}
									alt="Manager Signature"
									style={{ width: '300px', height: '180px' }}
								/>
							)}
							<div className="pl-5">
								<span className="font-bold">Timestamp:</span>
								{manager.timestamp}
							</div>
							<div className="pl-5 mb-5">
								<span className="font-bold">Name:</span>
								{manager.name}
							</div>
						</div>
					</div>
				</div>

				{/* Manager Note */}
				<div className="bg-gray-100 border-2 border-black p-3 mb-6">
					<p className="text-xs text-black m-0">
						<span className="font-semibold">Note:</span> Manager approval
						indicates appropriate training received by the user. Manager to
						provide evidence if requested.
					</p>
				</div>
			</div>
		</div>
	);
}

export default Page2;
